module.exports = __webpack_public_path__ + "static/img/inv-4.a9566de.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/landing/inv-4.png
// module id = QJf2
// module chunks = 0